export default {
  generic: `<div class="generic"><h1 v-if="title && title.length > 0" v-text="title"></h1><div data-event="close" class="close">&#10006;</div>` +
    `<p v-if="text" v-text="text"></p>` +
    `<a v-if="URL" :href="URL" target="_blank" tabindex="1" v-text="linkLabel">LINK</a></div>`,

  tip: `<div class="tip"><p v-text="title"></p><div data-event="close" class="close">&#10006;</div></div>`,

  link: `<div data-event="open" v-bind:data-event-value="URL" data-event-target="_blank" class="link" v-text="linkLabel"></p><div data-event="close" class="close">&#10006;</div></div>`,

  annotation: `<div class="annotation"><h1 v-text="title"></h1><div data-event="close" class="close">&#10006;</div>` +
    `<p v-text="text"></p>` +
    `</div>`,

  ptag: `<div class="ptag"><h1 v-text="title"></h1><div data-event="close" class="close">&#10006;</div>` +
    `<p v-text="text"></p>` +
    `<div class='eyecatcher'><span class='eyecatcher-currency'>CHF</span><span class='eyecatcher-value' v-text="eyecatcher"></span>.--</div>` +
    `<div class='stock' v-text="stock"></div>` +
    `<a :href="URL" target="_blank" tabindex="1" v-text="linkLabel">Visit</a></div>`,

  advanced: `<div class="advanced"><h1 v-text="title"></h1><div data-event="close" class="close">&#10006;</div>` +
    `<p v-text="text"></p>` +
    `<a :href="URL" target="_blank" tabindex="1">Visit</a></div>`,

  includedFrame: `<div class="embed"><h1 v-text="title"></h1><div data-event="close" class="close">&#10006;</div>` +
    `<p v-text="text"></p>` +
    `<span target="_blank" tabindex="1" data-event="open" data-event-target="iframe" v-bind:data-event-value="URL" v-text="linkLabel">Visit</span></div>`,

  branchTo: `<div class="branchTo"><h1 v-text="title"></h1><div data-event="close" class="close">&#10006;</div>` +
    `<p v-text="text"></p>` +
    `<span target="_blank" tabindex="1" data-event="open" data-event-target="_self" v-bind:data-event-value="URL" v-text="linkLabel">Visit</span></div>`
}
